import { getCurrentInstance, inject, computed, watch, onUnmounted, resolveComponent, openBlock, createBlock, withCtx, withDirectives, createElementVNode, normalizeClass, renderSlot, vShow } from 'vue';
import { createComponent } from './utils/create-component';
import { TABS_CONTEXT_KEY } from './utils/constants';
import Transition from './transition';
import propTypes from './utils/prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 标签值
   */
  label: propTypes.string().def(''),
  /**
   * 唯一标识
   */
  id: propTypes.oneOfType([propTypes.string(), propTypes.number()]).re(),
  /**
   * 是否展示切换动画，默认为true
   */
  isAnimated: propTypes["boolean"]().def(true)
};

var _createComponent = createComponent('tab-panel'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  components: _defineProperty({}, Transition.name, Transition),
  setup: function setup(props) {
    var panelInstance = getCurrentInstance();
    var uid = panelInstance.uid;
    var tabsContext = inject(TABS_CONTEXT_KEY);
    if (!tabsContext) {
      console.log('必须和tab一起使用');
    }
    tabsContext && tabsContext.addPanel(uid, panelInstance);
    var active = computed(function () {
      return tabsContext && tabsContext.activeIndex === tabsContext.panelsMap[uid];
    });
    var transitionName = computed(function () {
      // 如果不需要动画，则没有切换效果
      if (props.isAnimated === false) return '';
      var active = tabsContext && +tabsContext.activeIndex;
      var prev = tabsContext && +tabsContext.prevActiveIndex;
      if (active > prev) {
        return "tabs-transition-slide-left";
      }
      return "tabs-transition-slide-right";
    });
    // 监听label变化
    watch(function () {
      return props.label;
    }, function () {
      tabsContext && tabsContext.updatePanel(uid, panelInstance);
    });
    onUnmounted(function () {
      tabsContext && tabsContext.removePanel(uid, panelInstance);
    });
    return {
      active: active,
      className: className,
      transitionName: transitionName
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_transition = resolveComponent("sp-transition");
  return openBlock(), createBlock(_component_sp_transition, {
    name: _ctx.transitionName
  }, {
    "default": withCtx(function () {
      return [withDirectives(createElementVNode("div", {
        "class": normalizeClass(_ctx.className)
      }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), [[vShow, _ctx.active]])];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]);
}

script.render = render;
script.__file = "components/src/component/tab-panel/tab-panel.vue";

var _TabPanel = script;

export { _TabPanel as default };
